<select class="velocity-select">
  <option *ngFor="let speed of speeds" [value]="speed">x {{ speed }}</option>
</select>
